// The minimum for a usage to not be an "unusual" usage
export const MIN_USAGE_FOR_USUAL = 100
